import { render, staticRenderFns } from "./deduction-pay.vue?vue&type=template&id=0b020764&scoped=true&"
import script from "./deduction-pay.vue?vue&type=script&lang=js&"
export * from "./deduction-pay.vue?vue&type=script&lang=js&"
import style0 from "./deduction-pay.vue?vue&type=style&index=0&id=0b020764&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b020764",
  null
  
)

export default component.exports